import { render, staticRenderFns } from "./PurchaseSfsLxOption.vue?vue&type=template&id=4abff014&scoped=true"
import script from "./PurchaseSfsLxOption.vue?vue&type=script&lang=js"
export * from "./PurchaseSfsLxOption.vue?vue&type=script&lang=js"
import style0 from "./PurchaseSfsLxOption.vue?vue&type=style&index=0&id=4abff014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abff014",
  null
  
)

export default component.exports